import { Provider, Signal } from "@angular/core";
import { ATOM_SORT_HEADER_SORT_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "atom_table";

/**
 * Localizes the default `atomSortHeader` action label, which otherwise falls
 * back to the design system's English `'Sort'`.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}.
 *
 * Scope note: the label lands on an inner `aria-hidden`, `tabindex="-1"`
 * button, so assistive tech announces the `<th>`'s `aria-sort` instead. This
 * provider exists to satisfy the audit's i18n requirement, not to change what
 * a screen reader reads out.
 */
export const provideAtomSortHeaderLabels = (): Provider[] => [
    {
        provide: ATOM_SORT_HEADER_SORT_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.sort_label`),
    },
];
